const HeartSelected = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
    return (
        <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M9.76008 3.64921L9.13565 4.19563C6.74932 1.11477 3.38062 1.66119 2.56529 4.39327C1.67439 7.37337 5.18628 13.725 6.98796 14.1435C8.78964 14.562 15.1611 9.74505 15.2685 5.50548C15.3759 1.26591 11.1163 2.71527 9.76008 3.64921Z"
                fill="#FF8773"
            />
            <path
                d="M16.0281 3.91666C15.4912 2.51768 13.6895 1.84725 12.1663 2.13015C10.9521 2.41196 9.83715 3.00463 8.93676 3.84691C8.74938 3.33097 8.46025 2.85572 8.08564 2.44792C6.62202 0.859055 3.83002 0.448273 2.19538 1.87051C0.560742 3.29274 0.604492 5.66442 1.1096 7.68345C1.72607 10.0357 4.95557 15 6.56237 15C8.16916 15 14.3259 10.1636 15.6702 7.04402C16.0958 6.04032 16.41 4.92036 16.0281 3.91666Z"
                stroke="#686058"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default HeartSelected
